import { isOfflineStatus } from '../../../offline/domain/offlineOrder/offlineOrder.types';
import { StatusType } from '../../order.types';
import {
  CanForceReverseSyncOrderParams,
  CanForceSyncOrderParams,
} from '../../sync/forceSyncOrder.utils';
import { GetActionsParams, Role } from '../types/actions.types';

const getOrderStatus = (status: GetActionsParams['status']) =>
  isOfflineStatus(status) ? undefined : (status as StatusType);

export const toForceSyncOrderParams = (
  params: Readonly<GetActionsParams>,
): CanForceSyncOrderParams => ({
  isAdminBrand: params.role === Role.ADMIN_MARCA,
  integrationName: params.integrationName,
  hasOrderIntegration: params.hasOrderIntegration,
  orderStatus: getOrderStatus(params.status),
  orderStatusSync: params.synchronized,
  triggerIntegrationConfig: params.triggerIntegrationConfig as StatusType | undefined,
});

export const toForceReverseSyncOrderParams = (
  params: Readonly<GetActionsParams>,
): CanForceReverseSyncOrderParams => ({
  isAdminBrand: params.role === Role.ADMIN_MARCA,
  integrationName: params.integrationName,
  hasOrderIntegration: params.hasOrderIntegration,
  canForceReverseOrderSync: !!params.canForceReverseOrderSync,
  orderStatusSync: params.synchronized,
});
